module.exports = __webpack_public_path__ + "static/media/newzealand.61f66a9d.png";